import $ from "jquery";
export default {
  init() {
    $.fn.isInViewport = function () {
      var elementTop = $(this).offset().top;
      var elementBottom = elementTop + $(this).outerHeight();

      var viewportTop = $(window).scrollTop();
      var viewportBottom = viewportTop + $(window).height();

      return elementBottom > viewportTop && elementTop + 300 < viewportBottom;
    };

    // $(".hamburger").on("click", function () {
    //   $(this).toggleClass("is-active");
    // });

    $(window).on("resize scroll", function () {
      if ($(window).scrollTop() > 100) {
        $("header").addClass("scrolled");
      } else {
        //remove the background property so it comes transparent again (defined in your css)
        $("header").removeClass("scrolled");
      }
      $("#carouselId_kom").each(function (i, el) {
        if ($(this).isInViewport()) {
          //do something
          $(".section--name").text("");
          $("header").removeClass("extendHamburger");
        }
      });
      $("#singleNotikums").each(function (i, el) {
        if ($(this).isInViewport()) {
          //do something
          $(".section--name").text(this.dataset.headertitle);
          //$(".section--name").wrapAll('<a href="/#notikumi"></a>');
          $(".section--name").wrapAll('<a href="/#notikumi"></a>');
          $("header").removeClass("extendHamburger");
        }
      });
      $("#singleBlogs").each(function (i, el) {
        if ($(this).isInViewport()) {
          //do something
          $(".section--name").text(this.dataset.headertitle);
          $(".section--name").wrapAll('<a href="/#blogs"></a>');
          $("header").removeClass("extendHamburger");
        }
      });
      $("#singleFriends").each(function (i, el) {
        if ($(this).isInViewport()) {
          //do something
          $(".section--name").text(this.dataset.headertitle);
          $(".section--name").wrapAll('<a href="/"></a>');
          $("header").removeClass("extendHamburger");
        }
      });
      $("#singleFaq").each(function (i, el) {
        if ($(this).isInViewport()) {
          //do something
          $(".section--name").text(this.dataset.headertitle);
          $(".section--name").wrapAll('<a href="/"></a>');
          $("header").removeClass("extendHamburger");
        }
      });
      $("#singleGalerija").each(function (i, el) {
        if ($(this).isInViewport()) {
          //do something
          $(".section--name").text(this.dataset.headertitle);
          $(".section--name").wrapAll('<a href="/#galerijas"></a>');
          $("header").removeClass("extendHamburger");
        }
      });
      $("#programma").each(function (i, el) {
        if ($(this).isInViewport()) {
          //do something
          $(".section--name").text(this.dataset.headertitle);
          $("header").addClass("extendHamburger");
        }
      });
      $("#klara").each(function (i, el) {
        if ($(this).isInViewport()) {
          //do something
          $(".section--name").text(this.dataset.headertitle);
          $("header").addClass("extendHamburger");
        }
      });
      $("#notikumi").each(function (i, el) {
        if ($(this).isInViewport()) {
          //do something
          $(".section--name").text(this.dataset.headertitle);
          $("header").addClass("extendHamburger");
        }
      });
      $("#blogs").each(function (i, el) {
        if ($(this).isInViewport()) {
          //do something
          $(".section--name").text(this.dataset.headertitle);
          $("header").addClass("extendHamburger");
        }
      });
      $("#parmums").each(function (i, el) {
        if ($(this).isInViewport()) {
          //do something
          $(".section--name").text(this.dataset.headertitle);
          $("header").addClass("extendHamburger");
        }
      });
      $("#galerijas").each(function (i, el) {
        if ($(this).isInViewport()) {
          //do something
          $(".section--name").text(this.dataset.headertitle);
          $("header").addClass("extendHamburger");
        }
      });
      $("#telpas_wrap").each(function (i, el) {
        if ($(this).isInViewport()) {
          //do something
          $(".section--name").text(this.dataset.headertitle);
          $("header").addClass("extendHamburger");
        }
      });
      $("#kontakti").each(function (i, el) {
        if ($(this).isInViewport()) {
          //do something
          $(".section--name").text(this.dataset.headertitle);
          $("header").addClass("extendHamburger");
        }
      });
      //   {
      //   $(".section--name").text("");
      //   $("header").removeClass("extendHamburger");
      // }
    });



    $("#carouselId_kom").on("slid.bs.carousel", function (e) {
      var $e = $(e.relatedTarget);
      var idx = $e.index();
      var totalItems = $("#carouselId_kom .carousel-item").length;
      var itemsPerSlide = totalItems;
      //console.log("asdh");

      if (idx >= totalItems - (itemsPerSlide - 1)) {
        var it = itemsPerSlide - (totalItems - idx);
        for (var i = 0; i < it; i++) {
          // append slides to end
          if (e.direction === "left") {
            $("#carouselExample .carousel-item")
              .eq(i)
              .appendTo("#carouselExample .carousel-inner");
          } else {
            $("#carouselExample .carousel-item")
              .eq(0)
              .appendTo("#carouselExample .carousel-inner");
          }
        }
      }
    });

    //  $("#carouselId_kom, #carouselId").carousel({
    //    interval: 2000
    //  });



    //    $("a").on("click", function () {
    //      //console.log('mmmm');
    //    //$(".hamburger").removeClass("is-active");
    //  });

    // $("a[href='#top']").on("click", function () {
    //   window.scrollTo({
    //     top: 0,
    //     behavior: 'smooth'
    //   });
    //   return false;
    // });


    var elem = $(".blogs-single-card-text-content");

    elem.each(function () {
      //console.log($(".hamburger").height());
      if ($(this).height() > 370) {
        $(this).addClass("expandable");
      }
    });


    // $(".nav-link").each(function() {
    //   $(this).on("click", function () {
    //     console.log('mmmm');
    //   $(".hamburger").removeClass("is-active");
    // });
    // });



    // $('a').on("click", function (e) {
    //   //console.log('mmmm');
    //   $(".hamburger").removeClass("is-active");
    // });

    $(".readmorebtn").each(function () {
      $(this).on("click", function () {
        $(this)
          .siblings(".blogs-single-card-text-content")
          .toggleClass("expandable_fullheight");
      });
    });

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  }
};